<template>
  <div >
    <div class="row no-gutters row-bordered row-border-light">
      <div class="col-lg-5 col-12 pt-0 px-1 py-3" >
        <div v-if="show">
          <charts-home-page></charts-home-page>
        </div>


        <div v-if="!show">
          <button @click="close()" type="button" class=" btn btn-dark btn-sm " style="font-size: 10px; float: right; padding: 0px 6px;">
            &times;
          </button>
          <p class="font-weight-bold">{{station_id_trap.split('_')[0]}} </p>
          <div class="" style="padding-bottom: 0.5rem!important; ">
          <b-card-group deck class="px-3 " style="font-size: 11px;" >
            <b-card  border-variant="secondary" header="Country:" header-bg-variant="info"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].nuts0_name }}</b-card-text>
            </b-card>
            <b-card  border-variant="secondary" header="Country Code:" header-bg-variant="info"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].country_code }}</b-card-text>
            </b-card>

            <b-card border-variant="secondary" header="Group of development regions:" header-bg-variant="info"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].nuts1_name }}</b-card-text>
            </b-card>
          </b-card-group>
          <b-card-group deck class="px-3 mt-1" style="font-size: 11px;" >
            <b-card  border-variant="secondary" header="Region:" header-bg-variant="dark"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].nuts2_name }}</b-card-text>
            </b-card>
            <b-card  border-variant="secondary" header="Regional Unit:" header-bg-variant="dark"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].nuts3_name }}</b-card-text>
            </b-card>

            <b-card border-variant="secondary" header="Municipality:" header-bg-variant="dark"
                    header-text-variant="white"
                    align="center">
              <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].lau1_municipality }}</b-card-text>
            </b-card>
          </b-card-group>
            <b-card-group deck class="px-3 mt-1" style="font-size: 11px;" >
              <b-card  border-variant="secondary" header="DEM:" header-bg-variant="info"
                       header-text-variant="white"
                       align="center">
                <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].dem_mean_1km }} m</b-card-text>
              </b-card>
              <b-card  border-variant="secondary" header="ASPECT:" header-bg-variant="info"
                       header-text-variant="white"
                       align="center">
                <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].aspect_mean_1km }} degrees</b-card-text>
              </b-card>

              <b-card border-variant="secondary" header="SLOPE:" header-bg-variant="info"
                      header-text-variant="white"
                      align="center">
                <b-card-text style="font-size: 13px;" >{{ chart_data.data[0].slope_mean_1km }} degrees</b-card-text>
              </b-card>
            </b-card-group>
            <b-card-group deck class="px-3 mt-1" style="font-size: 12px;" >
              <b-card  border-variant="secondary" header="Settlement:" header-bg-variant="dark"
                       header-text-variant="white"
                       align="center">
                <b-card-text style="font-size: 13px;" >{{ }}</b-card-text>
              </b-card>
              <b-card  border-variant="secondary" header="Trap :" header-bg-variant="dark"
                       header-text-variant="white"
                       align="center">
                <b-card-text v-if="mosquito_type==='aedes'" style="font-size: 13px;" >{{ mosquito_type }} - {{chart_data.data[0].genus}}</b-card-text>
                <b-card-text v-else style="font-size: 13px;" >{{ mosquito_type }}</b-card-text>
              </b-card>

            </b-card-group>
            <b-form-select  v-model="selected" class="mb-3" @change="ChartPerYear">
              <!-- This slot appears above the options from 'options' prop -->
              <template #first>
                <b-form-select-option :value="null" disabled>-- Select year --</b-form-select-option>
              </template>

              <!-- These options will appear after the ones from 'options' prop -->
              <b-form-select-option v-for="year in years" :key="year" :value="year" >{{year}}</b-form-select-option>
            </b-form-select>
        </div>

        </div>
        <div :style="{ display }" style="overflow:scroll; max-height: 57vh;"  >
          <vue-highcharts  :options="optionsndmi" ref="lineChartsno_total" style="height: 25vh;"></vue-highcharts>

          <vue-highcharts  :options="optionsndmi" ref="lineChartsndmi" style="height: 25vh;"></vue-highcharts>
          <vue-highcharts  :options="optionsLST" ref="lineChartsLST" style="height: 25vh;"></vue-highcharts>
          <vue-highcharts  :options="optionsRain" ref="lineChartsrainfall" style="height: 25vh;"></vue-highcharts>
          <vue-highcharts  :options="optionsWind" ref="lineChartsmean_wind" style="height: 25vh;"></vue-highcharts>
          

        </div>
      </div>
      <div class="col-lg-7 col-12 px-2 py-3">

        <div class="border border-dark">
          <div class="p-1" style="height:85vh; background-color: white">

            <l-map  :zoom="zoom" :center="center" ref="myMap">
              <l-tile-layer :url="url"></l-tile-layer>

              <l-control class="example-custom-control" style="width:200px" >
                <div style="background-color: white; color: white" class="rounded">

                  <div class="p-1">
                    <p class="bold text-dark font-weight-bold text-center" style="font-size: 14px">Mosquitoes:</p>
                    <div class="p-1 rounded" style="background-color: #0a6715">
                      <b-form-checkbox v-model="visible_culex">Culex</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="p-1 rounded" style="background-color: #e9820c">
                      <b-form-checkbox v-model="visible_aedes">Aedes</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="p-1 rounded" style="background-color: #fc0404">
                      <b-form-checkbox v-model="visible_anopheles">Anopheles</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="p-1 d-flex" style="color: #050505">
                      <b-icon class="mt-2" icon="flag-fill" scale="1.5" >
                       </b-icon>
                      <p class="bold px-2 text-dark font-weight-bold text-center" style="font-size: 14px">Periodical Traps</p>
                    </div>
                  </div>
                </div>
                <div>
                 <b-form-select  v-model="selectedCountry" class="mt-2" @change="ChangeCountry">
                    <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option v-for="country_name in country" :key="country_name.id"  :value="country_name.id" >{{country_name.name}}</b-form-select-option>
                 </b-form-select>
                  <b-form-select  v-model="selectedTrapsDataYear" @change="ChangeTrapsDataYear">
                    <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option v-for="year in years_traps_data" :key="year.extractYear+'year'"  :value="year.extractYear" >{{year.extractYear}}</b-form-select-option>
                 </b-form-select>
                 </div>
              </l-control>
              <div v-if="!tst" class="loader"></div>
              <l-marker
                ref="marker"
                v-for="col in data_Loc" :lat-lng="[col.longitude, col.latitude]" :key="col.id"
                :icon="icons(col)"
                :visible="isVisible(col.mosquito_type)"
                @click="modal_charts(col)">
                
                <l-popup ref="popup" :options="{offset:[0,-10]}">{{station_id_trap.split('_')[0]}}</l-popup>
                <l-tooltip>{{col.station_id.split('_')[0]}}</l-tooltip>
              </l-marker>
              <l-polygon ref="polygon_country"
                v-for="countryData in polygon.latlngs" :key="countryData.id" :lat-lngs="countryData"
              />

            </l-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios-auth'
import {LMap, LTileLayer, LCircleMarker,LGeoJson,LMarker,LIcon, LControl,LPolygon,LTooltip,LPopup  } from 'vue2-leaflet';
import { icon } from "leaflet";
import VueHighcharts from 'vue2-highcharts'
import ChartsHomePage from '../components/ChartsHomePage.vue';
import routes from '../routes/routes'
export default {
  components: {
    ChartsHomePage,
    LPopup,
    LTooltip,
    LMap,
    LTileLayer,
    LCircleMarker,
    VueHighcharts,
    LMarker,
    LIcon,
    LControl,
    LGeoJson,
    LPolygon
    
  },
  mounted() {

  },
  data () {
    return {
      selectedTrapsDataYear:null,
      years_traps_data:null,
      selected_country_old:null,
      station_id_trap:'',
      tst:false,
      polygon: {
        latlngs: [],
      },
      selectedCountry:null,
      selected:null,
      display: 'none',
      show: true,
      showw: false,
      visible_culex: true,
      visible_aedes: true,
      visible_anopheles: true,
      chart_data:[],
      years:[],
      yearNoSort:[],
      country:'',
      test:'',
      num:null,
      mosquito_type:'',
     
      charts:[],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 3,
      center: [43.6659, 17.1937],
      data_Loc:{},

      //geojson: null,
      //     markerLatLng: {[47.313220, -1.319482],[47.41322, -1.219482]},

      optionsndmi:{
        chart: {
          type: 'column'

        },
        tooltip: {
        valueDecimals: 2,
        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'',},
          tickAmount: 10
        },
        credits: {
          enabled: false
        },
        series: [],
      },
      optionsRain:{
        chart: {
          type: 'column'

        },
        tooltip: {
        valueDecimals: 2,
        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'mm',},
          tickAmount: 10
        },
        credits: {
          enabled: false
        },
        series: [],
      },
       optionsLST:{chart: {type: 'column'},title: {text: ''},
        yAxis: {
          title: {text:'Celsius',},
          tickAmount: 10
        },
        tooltip: {
        valueDecimals: 2,
        },
        credits: {
          enabled: false
        },
        series: [],
      },

      optionsWind:{
        chart: {
          type: 'column'

        },
        tooltip: {
        valueDecimals: 2,
        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'m/sec',},
          tickAmount: 10
        },
        credits: {
          enabled: false
        },
        series: [],
      },
      group:null

    };
  },
  async created () {
    //const response = await fetch('https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson');
    //this.geojson = await response.json();
    var country_geom=null
    var user =JSON.parse(localStorage.getItem('user'))
    this.group = user.groups
    //console.log(user)
    //console.log(group)
    country_geom=await axios.get('entomologicalData/country/',{params:{group:JSON.stringify(this.group)}})
    

    this.country=country_geom.data
    //console.log(this.country)
    for(var i=0; i<country_geom.data.length; i++) {

      // console.log(geojson_pgons)

      const latlgn = L.geoJSON(JSON.parse(this.country[i].json))
      const latlgn_id = latlgn._leaflet_id - 1
      // console.log(latlgn)
      const latlgn_data = latlgn._layers[latlgn_id]._latlngs

      this.polygon.latlngs[i] = latlgn_data
    }
    //console.log(this.polygon)

    var data=null
    
    var years_traps_data_all=await axios.get('distinct-years-entomological-data/')
    this.years_traps_data=years_traps_data_all.data
    this.selectedTrapsDataYear=this.years_traps_data[0].extractYear
    data=await axios.get('entomologicalData/markers/',{params:{year:this.selectedTrapsDataYear,group:JSON.stringify(this.group)}})
  

    this.data_Loc=data.data
    console.log(this.data_Loc)
    this.tst=true
  },
  methods:{
    async ChangeTrapsDataYear(){
    
    var data=await axios.get('entomologicalData/markers/',{params:{year:this.selectedTrapsDataYear,group:JSON.stringify(this.group)}})
    //this.$refs.marker[0].mapObject.closePopup()
    this.data_Loc=data.data
    console.log(this.data_Loc)
    this.selected=this.selectedTrapsDataYear
     this.$refs.marker.forEach(element => element.mapObject.closePopup());
     if(this.years.includes(this.selected)){
        //this.display='block'
        this.AddSeries()
      }else{
        this.display='none'
      }
    
    },
    icons(item){
      if(item.mosquito_type==='culex' ){
        if(item.trapscount>5) {
          return icon({
            iconUrl: "/img/icon-green.png",
            iconSize: [40, 40],
          })
        }
        else{
          return icon({
            iconUrl: "/img/icon-green-info.png",
            iconSize: [20, 20],
          })
        }
      }

      if(item.mosquito_type==='aedes'){
       
        return icon({
          iconUrl: "/img/icon-orange.png",
          iconSize: [40, 40],
        })
      }
      if(item.mosquito_type==='anopheles'){
        if(item.trapscount>5) {
          return icon({
            iconUrl: "/img/icon-red.png",
            iconSize: [35, 35],
          })
        }
        else {
          return icon({
            iconUrl: "/img/icon-red-info.png",
            iconSize: [20, 20],
          })
        }
      }
    },
    isVisible(item){
      if(item==='culex'){
        return this.visible_culex
      }
      if(item==='aedes'){
        return this.visible_aedes
      }
      if(item==='anopheles'){
        return this.visible_anopheles
      }

    },
   async modal_charts(col){

      this.show=false

      console.log(col)
      this.station_id_trap=col.station_id
      const token = localStorage.getItem('token')
        if(col.mosquito_type==='culex') {
          this.chart_data = await axios.get('entomologicalData/culex/', {  headers: { Authorization: `Bearer ${token}` } , params: {station_id: col.station_id,country_code:col.country_code}})////.catch(error=> routes.replace('/'))
          console.log(this.chart_data.data)
        }
        if(col.mosquito_type==='aedes') {
          this.chart_data = await axios.get('entomologicalData/aedes/', { headers: { Authorization: `Bearer ${token}` },params: {station_id: col.station_id}})////.catch(error=> routes.replace('/'))
          console.log(this.chart_data.data)
        }
        if(col.mosquito_type==='anopheles') {
          this.chart_data = await axios.get('entomologicalData/anopheles/', { headers: { Authorization: `Bearer ${token}` },params: {station_id: col.station_id}})////.catch(error=> routes.replace('/'))
          console.log(this.chart_data.data)
          this.chart_data.data[0].dem_mean_1km=0
          this.chart_data.data[0].aspect_mean_1km=0
          this.chart_data.data[0].slope_mean_1km=0
        }
        this.charts=[]
        this.years=[]
        this.yearNoSort=[]

        //let weeks=[]
        //console.log(this.chart_data.data)
        for(var i=0; i<this.chart_data.data.length; i++){

          if(!this.years.includes(this.chart_data.data[i].year)){
            //console.log('here')
            this.yearNoSort.push(this.chart_data.data[i].year)
            this.years.push(this.chart_data.data[i].year)
            this.charts.push({year: this.chart_data.data[i].year})
          }
          //console.log(years.indexOf(this.chart_data.data[i].year))
          //console.log(this.charts[years.indexOf(this.chart_data.data[i].year)])
          var type_of_culex
              if(this.chart_data.data[i].year>2019){
                type_of_culex='culex_pipiens'
              }else{
                type_of_culex='no_culex_total'
              }

          if(this.charts[this.years.indexOf(this.chart_data.data[i].year)].weeks) {
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].weeks.push(this.chart_data.data[i].week)
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndmi_mean.push(this.chart_data.data[i].ndmi_mean)
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndvi_mean.push(this.chart_data.data[i].ndvi_mean)
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndwi_mean.push(this.chart_data.data[i].ndwi_mean)
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].acc_rainfall_1week.push(this.chart_data.data[i].acc_rainfall_1week)
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].mean_wind.push(this.chart_data.data[i].mean_wind)
            if(this.chart_data.data[i].lst_day===0 || this.chart_data.data[i].lst_day===null ){
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_day.push(this.chart_data.data[i].lst_day)
            }
            else{
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_day.push(this.chart_data.data[i].lst_day*0.02-273.15)
            }
            if(this.chart_data.data[i].lst_night===0 || this.chart_data.data[i].lst_night===null ){
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_night.push(this.chart_data.data[i].lst_night)
            }
            else{
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_night.push(this.chart_data.data[i].lst_night*0.02-273.15)
            }
            
            if(col.mosquito_type==='culex') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total.push(parseInt(this.chart_data.data[i][type_of_culex]))
            }
            if(col.mosquito_type==='aedes') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total.push(this.chart_data.data[i].aedes_eggs)
            }
            if(col.mosquito_type==='anopheles') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total.push(this.chart_data.data[i].anopheles_total)
            }
          }else{
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].weeks = [this.chart_data.data[i].week]
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndmi_mean = [this.chart_data.data[i].ndmi_mean]
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndvi_mean = [this.chart_data.data[i].ndvi_mean]
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].ndwi_mean = [this.chart_data.data[i].ndwi_mean]
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].acc_rainfall_1week = [this.chart_data.data[i].acc_rainfall_1week]
            this.charts[this.years.indexOf(this.chart_data.data[i].year)].mean_wind = [this.chart_data.data[i].mean_wind]
            if(this.chart_data.data[i].lst_day===0 || this.chart_data.data[i].lst_day===null ){
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_day = [this.chart_data.data[i].lst_day]
            }else{
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_day = [this.chart_data.data[i].lst_day*0.02-273.15]
            }
            if(this.chart_data.data[i].lst_night===0 || this.chart_data.data[i].lst_night===null ){
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_night = [this.chart_data.data[i].lst_night]
            }else{
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].lst_night = [this.chart_data.data[i].lst_night*0.02-273.15]
            }
            if(col.mosquito_type==='culex') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total = [parseInt(this.chart_data.data[i][type_of_culex])]
            }
            if(col.mosquito_type==='aedes') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total = [this.chart_data.data[i].aedes_eggs]
            }
            if(col.mosquito_type==='anopheles') {
              this.charts[this.years.indexOf(this.chart_data.data[i].year)].no_total = [this.chart_data.data[i].anopheles_total]
            }
          }

          //push({week: this.chart_data.data[i].week})
          // weeks.push(this.chart_data.data[i].week)
        }
        //this.yearNoSort=this.years
        this.years.sort(function(a, b){return a - b})

        //console.log(Object.values(this.charts))
       console.log(this.charts)

     this.mosquito_type= col.mosquito_type
     console.log(this.mosquito_type)
     console.log(this.mosquito_type)
     
      this.selected=this.selectedTrapsDataYear
     if(this.selected ){

       if(this.years.includes(this.selected)){
        this.display='block'
        this.AddSeries()
       }
       else{
         this.display='none'
         this.selected=null
       }


     }



   },
    close(){
      this.show=true
      this.display='none'
      this.selected=null
    },
    /*
    markerHover(col){
      console.log(col)
      if(col.lau1_municipality){
      this.markerhover=col.lau1_municipality
      }
      else{
        this.markerhover=col.nuts3_name
      }
    },
    */
    AddSeries(){
      var lineChartsndmi = this.$refs.lineChartsndmi
      var lineChartsrainfall = this.$refs.lineChartsrainfall
      var lineChartsmean_wind = this.$refs.lineChartsmean_wind
      var lineChartsno_total= this.$refs.lineChartsno_total
      var lineChartsLST= this.$refs.lineChartsLST

      const num=this.yearNoSort.indexOf(this.selected)
      //console.log(weeks)
      lineChartsndmi.getChart().xAxis[0].setCategories(this.charts[num].weeks)
      lineChartsrainfall.getChart().xAxis[0].setCategories(this.charts[num].weeks)
      lineChartsmean_wind.getChart().xAxis[0].setCategories(this.charts[num].weeks)
      lineChartsno_total.getChart().xAxis[0].setCategories(this.charts[num].weeks)
      lineChartsLST.getChart().xAxis[0].setCategories(this.charts[num].weeks)
      

      if (lineChartsndmi) {
        lineChartsndmi.removeSeries()
        lineChartsrainfall.removeSeries()
        lineChartsno_total.removeSeries()
        lineChartsmean_wind.removeSeries()
        lineChartsLST.removeSeries()
      }

      //console.log(this.charts[0].ndmi_mean)
      var no_total_message= ''
      if(this.mosquito_type==='culex'){
        no_total_message='Number of Culex mosquitoes collected'
      }
      if(this.mosquito_type==='aedes'){
        no_total_message='Number of Aedes collected'
      }
      if(this.mosquito_type==='anopheles'){
        no_total_message='Number of Anopheles mosquitoes collected'
      }

      lineChartsndmi.addSeries({
        name: 'ndmi',
        data: this.charts[num].ndmi_mean
      })
      lineChartsndmi.addSeries({
        name: 'ndvi',
        data: this.charts[num].ndvi_mean
      })
      lineChartsndmi.addSeries({
        name: 'ndwi',
        data: this.charts[num].ndwi_mean
      })
      lineChartsrainfall.addSeries({
        name: 'Rainfall',
        data: this.charts[num].acc_rainfall_1week
      })
      lineChartsmean_wind.addSeries({
        name: 'Wind Speed',
        data: this.charts[num].mean_wind
      })
      lineChartsno_total.addSeries({
        name: no_total_message,
        data: this.charts[num].no_total
      })
      lineChartsLST.addSeries({
        name: 'LST Day',
        data: this.charts[num].lst_day
      })
      lineChartsLST.addSeries({
        name: 'LST Night',
        data: this.charts[num].lst_night
      })

    },
    ChartPerYear(){

      this.display='block'


      //this.chart.series[0].setData( {data: this.charts[0].ndmi_mean}, true)
      //console.log(this.yearNoSort)
      //console.log(this.yearNoSort.indexOf(this.selected))

      //console.log(lineChartsndmi)
      this.AddSeries()
    },
    ChangeCountry(){
    //console.log(this.$refs.polygon_country)
    

    this.$refs.polygon_country[this.selectedCountry-1].fillColor='#EC008C'
    this.$refs.polygon_country[this.selectedCountry-1].color='#EC008C'
    if(this.selected_country_old){
      this.$refs.polygon_country[this.selected_country_old-1].fillColor='#3388ff'
      this.$refs.polygon_country[this.selected_country_old-1].color='#3388ff'
    }
    this.selected_country_old=this.selectedCountry
     if(this.selectedCountry===4){
       this.$refs.myMap.mapObject.fitBounds([[46.2634502432201,13.0569594997323],[43.6924119881264,12.1465820717025]])
     }else if(this.selectedCountry===3){
       this.$refs.myMap.mapObject.fitBounds([[40.7634502432201,24.8569594997323],[35.5924119881264,20.6465820717025]])

     }else if(this.selectedCountry===1){
       this.$refs.myMap.mapObject.fitBounds([[48.864716,2.349014],[40.864716,6.349014]])

     }else if(this.selectedCountry===2){
       this.$refs.myMap.mapObject.fitBounds([[52.520008,15.404954],[46.520008,8.404954]])

     }else if(this.selectedCountry===5){
       this.$refs.myMap.mapObject.fitBounds([[47.787197,23.8569594997323],[41.087197,18.6465820717025]])

     }

     },

  },

}
</script>

<style>
hr {
  margin-top: 0rem;
  margin-bottom: 0rem;
  width: 100%;
  border-top: 1px solid rgba(2, 2, 2, 1);
}
p{
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
}
.leaflet-container {
  font: 15px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
}
.card .card-header {
  padding: 0px 0px 0;
}
.card .card-body {
  padding: 0px 0px 0px 0px;
}
.card-deck .card {
  -ms-flex: 1 0 0%;
  -webkit-box-flex: 1;
    flex: 1 0 0%;
   margin-right: 3px;
   margin-bottom: 0;
   margin-left: 0px;
}
.bg-info {
  background-color: #00948A !important;
}
.loader{
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background: url('../../public/img/load1.gif') 50% 50% no-repeat rgba(255,193,249,0.5)

}

</style>
